import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  loading?: boolean;
  full?: boolean;
  children: ReactNode;
};

const base =
  "ring-nexus inline-flex items-center justify-center gap-2 rounded-[10px] " +
  "px-4 py-2.5 text-sm font-medium transition border " +
  "disabled:opacity-50 disabled:cursor-not-allowed";

const variants: Record<Variant, string> = {
  primary: "bg-red text-white border-transparent hover:bg-red-hover",
  secondary: "bg-elevated text-primary border-border-default hover:bg-overlay",
  ghost: "bg-transparent text-secondary border-transparent hover:text-primary hover:bg-overlay",
};

export function Button({ variant = "primary", loading, full, className, disabled, children, ...rest }: Props) {
  const cls = [base, variants[variant], full ? "w-full" : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <button {...rest} disabled={disabled || loading} className={cls}>
      {loading ? <Spinner /> : null}
      {children}
    </button>
  );
}

function Spinner() {
  return (
    <span
      aria-hidden
      className="inline-block w-3.5 h-3.5 rounded-full border-2 border-white/30 border-t-white animate-spin"
    />
  );
}
